export const getBookingStatusStyle = (booking, selectedWeek, companyCutOffTime, role, timezone, timeIsUp) => {
  if (timeIsUp(booking, selectedWeek, companyCutOffTime, role, timezone)) {
    return "bg-gray-200 text-gray-700";
  }

  const statusStyles = {
    booked: "bg-green-200 text-gray-700",
    incomplete: "bg-red-200 text-gray-700",
    updated: "bg-orange-200 text-gray-700",
    to_delete: "bg-red-400 text-gray-700",
    new: "bg-green-600 text-white"
  };

  return statusStyles[booking?.status] || "";
}; 